/**
 * Ordinary least-squares linear regression for an equally-spaced numeric
 * series. Returns a same-length array of fitted values that can be plotted
 * as a Recharts <Line> without its own axis.
 */
export function linearTrend(values: Array<number | null | undefined>): number[] {
  const xs: number[] = [];
  const ys: number[] = [];
  for (let i = 0; i < values.length; i += 1) {
    const v = values[i];
    if (typeof v === 'number' && Number.isFinite(v)) {
      xs.push(i);
      ys.push(v);
    }
  }
  if (xs.length < 2) return values.map((v) => (typeof v === 'number' ? v : 0));
  const n = xs.length;
  const meanX = xs.reduce((s, x) => s + x, 0) / n;
  const meanY = ys.reduce((s, y) => s + y, 0) / n;
  let num = 0;
  let den = 0;
  for (let i = 0; i < n; i += 1) {
    num += (xs[i] - meanX) * (ys[i] - meanY);
    den += (xs[i] - meanX) ** 2;
  }
  const slope = den === 0 ? 0 : num / den;
  const intercept = meanY - slope * meanX;
  return values.map((_, i) => intercept + slope * i);
}
